div.title
  | {{node.title}}

// Outputs
div(al-repeat='output in node.outputs',style="text-align: right")
  .output-title
    | {{output.title}}
  .socket.output(
    al-pick-output, 
    class="{{output.socket.id.toLowerCase().replace(' ','-')}}",
    title='{{output.socket.name}}\n{{output.socket.hint}}'
  )

// Controls
div.control(
  al-repeat='control in node.controls', 
  style="text-align: center",
  :width='control.parent.width - 2 * control.margin', 
  :height='control.height', 
  al-control='control'
)

// Inputs
div(al-repeat='input in node.inputs',style="text-align: left")
  .socket.input(
    al-pick-input,
    class="{{input.socket.id.toLowerCase().replace(' ','-')}} {{input.multipleConnections?'multiple':''}}"
    title='{{input.socket.name}}\n{{input.socket.hint}}'
  )
  .input-title(
    al-if='!input.showControl()'
  )
    | {{input.title}}
  .input-control(
    al-if='input.showControl()'
    al-control='input.control'
  )